module.exports = __webpack_public_path__ + "/298c748e39de28782795f4002325a638.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/megaphone_icon.svg
 ** module id = 1639
 ** module chunks = 0
 **/